var React = require('react');

function IconOutreach (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.78 8.758c-.706 0-1.278.58-1.278 1.297v3.89c0 .716.572 1.297 1.277 1.297.455 0 .835-.255 1.061-.617l4.272 1.309a3.892 3.892 0 00-.222 1.253c0 2.145 1.719 3.89 3.832 3.89 1.776 0 3.26-1.239 3.693-2.905l5.25 1.608V4.22L2.84 9.375c-.226-.362-.606-.617-1.06-.617zm7.157 7.735l3.652 1.12c-.192.867-.955 1.52-1.867 1.52-1.056 0-1.916-.873-1.916-1.946 0-.245.05-.478.131-.694zM22.86 2.923h-1.28a.643.643 0 00-.638.648V20.43c0 .358.285.648.638.648h1.278c.353 0 .639-.29.639-.648V3.57a.643.643 0 00-.64-.648z"}));
}

IconOutreach.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = IconOutreach;

IconOutreach.default = IconOutreach;
